"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.diffTimeZone = exports.str2time = exports.str2timestamp = void 0;
const dayjs_1 = __importDefault(require("dayjs"));
const duration_1 = __importDefault(require("dayjs/plugin/duration"));
const customParseFormat_1 = __importDefault(require("dayjs/plugin/customParseFormat"));
const config_1 = require("../../config");
dayjs_1.default.extend(duration_1.default);
dayjs_1.default.extend(customParseFormat_1.default);
function str2timestamp(value) {
    if (!value) {
        return null;
    }
    const dateTime = (0, dayjs_1.default)(value);
    return dateTime.isValid() ? dateTime.valueOf() : null;
}
exports.str2timestamp = str2timestamp;
/**
 *
 * Returns the number of milliseconds from 13:45 to 00:00
 * @export
 * @param {string} value 12:34
 * @param {IDateTimeField} [_field]
 * @returns
 */
function str2time(value, _field) {
    // const format = (field && field.property.timeFormat) || DateTimeField.defaultTimeFormat;
    // let dateTime = dayjs(value, format);
    // if (!dateTime.isValid()) {
    //   const format2 = format.replace(':', '');
    //   if (format2 !== format) {
    //     dateTime = dayjs(value, format2);
    //   }
    // }
    // if (!dateTime.isValid()) {
    //   return null;
    // }
    const [hh, mm] = value.split(':');
    const hours = parseInt(hh, 10);
    const minutes = parseInt(mm, 10);
    if (hours < 0 || hours > 23 || minutes < 0 || minutes > 59) {
        return;
    }
    return dayjs_1.default.duration({
        hours,
        minutes,
        // seconds: parseInt(s, 10),
        // milliseconds: dateTime.millisecond(),
    }).asMilliseconds();
}
exports.str2time = str2time;
const diffTimeZone = (timeZone) => {
    if (!timeZone)
        return 0;
    const tzOffset = (0, config_1.getTimeZoneOffsetByUtc)(timeZone);
    const clientTimeZone = (0, config_1.getTimeZone)();
    const clientTzOffset = (0, config_1.getTimeZoneOffsetByUtc)(clientTimeZone);
    return dayjs_1.default.duration({
        hours: clientTzOffset - tzOffset
    }).asMilliseconds();
};
exports.diffTimeZone = diffTimeZone;
//# sourceMappingURL=other2timestamp.js.map